<template>
  <filter-bar>
    <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
      <md-field>
        <label for="dateFrom">
          <md-icon>calendar_today</md-icon>
          <span v-show="!dateFrom">Desde</span>
        </label>
        <datetime
          input-style="border: none; outline:none; width: 100%"
          type="date"
          title="Desde"
          value-zone="America/Mexico_City"
          v-model="dateFrom"
          :phrases="{ ok: '', cancel: '' }"
          auto
        ></datetime>
        <md-button class="md-simple md-just-icon" @click="dateFrom = null">
          <md-icon>close</md-icon>
        </md-button>
      </md-field>
    </div>

    <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
      <md-field>
        <label for="dateOccurred">
          <md-icon>calendar_today</md-icon>
          <span v-show="!dateTo">Hasta</span>
        </label>
        <datetime
          input-style="border: none; outline:none; width: 100%"
          type="date"
          title="Hasta"
          value-zone="America/Mexico_City"
          v-model="dateTo"
          :phrases="{ ok: '', cancel: '' }"
          auto
        ></datetime>
        <md-button class="md-simple md-just-icon" @click="dateTo = null">
          <md-icon>close</md-icon>
        </md-button>
      </md-field>
    </div>

    <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
      <md-field>
        <label>Autopista</label>
        <md-select v-model="selectedHighway">
          <md-option :value="0">Todas</md-option>
          <md-option
            v-for="highway in highways"
            :key="highway.id"
            :value="highway.id"
          >{{highway.name}}</md-option>
        </md-select>
      </md-field>
    </div>
  </filter-bar>
</template>

<script>
import catalogService from "@/services/catalog";
import { Slider, Collapse } from "@/components";
import FilterBar from "@/components/FilterBar";
import moment from "moment";

export default {
  components: {
    Slider,
    Collapse,
    FilterBar,
  },
  data() {
    const { dateFrom, dateTo } = this.defaults;

    return {
      dateFrom:
        dateFrom === undefined
          ? moment().subtract(15, "days").format("YYYY-MM-DD")
          : dateFrom,
      dateTo,
      selectedHighway: null,
      highways: [],
    };
  },
  created() {
    catalogService
      .fetch("highway", { noStore: true })
      .then((highways) => (this.highways = highways));
  },
  props: {
    source: {
      type: Array,
      default: () => [],
    },
    dummyFilter: {
      type: Boolean,
      default: false,
    },
    defaults: {
      type: Object,
      default: () => ({}),
    },
  },

  watch: {
    defaults(value) {
      const { dateFrom, dateTo } = value;
      this.dateFrom =
        dateFrom === undefined
          ? moment().subtract(15, "days").format("YYYY-MM-DD")
          : dateFrom;
      this.dateTo = dateTo;
    },
    filteredData() {
      this.$emit("filtered", this.filteredData);
    },
    dateFrom(value) {
      this.$emit("updateDateFrom", value || null);
    },
    dateTo(value) {
      this.$emit("updateDateTo", value || null);
    },
    selectedHighway(value) {
      this.$emit("updateSelectedHighway", value || null);
    },
  },
  computed: {
    filteredData: function () {
      if (this.dummyFilter) {
        return this.source;
      }

      let dFrom = this.dateFrom;
      let dTo = this.dateTo;

      dFrom = dFrom && moment(dFrom);
      dTo = dTo && moment(dTo);
      const hi = this.selectedHighway;
      let filteredSource = this.source;

      if (dFrom) {
        filteredSource = filteredSource.filter((rS) =>
          rS.dateAssignment.isSameOrAfter(dFrom, "day")
        );
      }

      if (dTo) {
        filteredSource = filteredSource.filter((rS) =>
          rS.dateAssignment.isSameOrBefore(dTo, "day")
        );
      }

      if (hi) {
        filteredSource = filteredSource.filter((rS) => rS.highway == hi);
      }

      return filteredSource;
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}

.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}

.date-label {
  top: -9px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Reports/BudgetReport/Filter.vue